// extracted by mini-css-extract-plugin
export default {"container":"WUcQW","image":"Uq7jn","text":"XCi9O","title":"qdYcl","value":"zyHhD","button":"BgWHK","alternative":"yNS96","socials":"cThLc","social":"x3AbZ"};